const fullEleInvoiceIsAbnormalConfig = {
    version: 1.13,
    queryForm: [
        {
            // 0
            label: '纳税人名称',
            selected: true,
            default: true,
            name: 'orgName',
        },
        {
            label: '纳税人识别',
            selected: true,
            default: true,
            name: 'creditCode',
        },
        {
            label: '注册码授权状态',
            selected: true,
            default: true,
            name: 'authCodeGrantState',
            type: 'dict',
            dict: 'auth_code_grant_state',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        // {
        //     label: '主管税局省市',
        //     selected: false,
        //     default: false,
        //     name: 'taxBuName',
        //     // name: 'province',
        //     type: 'taxBureauId',
        // },
        {
            //10
            label: '注册码有效否',
            selected: false,
            default: false,
            name: 'authCodeState',
            type: 'dict',
            dict: 'yes_no_flag',
        },
        {
            label: '申请日期起止',
            selected: false,
            default: false,
            name: 'applyDate',
            type: 'date',
        },
        {
            label: '注册码有效日期起止',
            selected: false,
            default: false,
            name: 'authCodeVaildDate',
            type: 'date',
        },
        {
            label: '申请类型',
            selected: false,
            default: false,
            name: 'applyType',
            type: 'dict',
            dict: 'apply_type',
        },
    ],
    table: [
        {
            label: '纳税人名称',
            selected: true,
            default: true,
            name: 'orgName',
            sort: false,
        },
        {
            label: '纳税人识别号',
            selected: true,
            default: true,
            name: 'creditCode',
            sort: false,
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        {
            label: '所属区域',
            selected: false,
            default: false,
            sort: false,
            // name: 'regionName',
            name: 'bureauName',
        },
        // {
        //     label: '主管税局省市',
        //     selected: false,
        //     default: false,
        //     sort: false,
        //     name: 'taxBuName',
        // },
        {
            //10
            label: '注册码授权状态',
            sort: false,
            selected: true,
            default: true,
            name: 'authCodeGrantState',
            type: 'dict',
            dict: 'auth_code_grant_state',
        },
        {
            label: '通道类型',
            sort: false,
            selected: true,
            default: true,
            name: 'channelType',
            type: 'dict',
            dict: 'drawer_channel_type',
        },
        {
            label: '注册类别',
            sort: false,
            selected: false,
            default: false,
            name: 'registerType',
            type: 'dict',
            dict: 'belle_register_type',
        },
        {
            label: '授权代码',
            selected: false,
            default: false,
            sort: false,
            name: 'authCode',
        },
        {
            label: '申请日期',
            selected: false,
            default: false,
            sort: false,
            name: 'applyDate',
        },
        {
            label: '注册码授权日期',
            selected: true,
            default: true,
            sort: false,
            name: 'authCodeDate',
        },
        {
            label: '注册码有效期',
            selected: true,
            default: true,
            sort: false,
            name: 'authCodeVaildDate',
        },
        {
            label: '更新人',
            selected: false,
            default: false,
            sort: false,
            name: 'updateUser',
        },
        {
            label: '更新时间',
            selected: false,
            default: false,
            sort: false,
            name: 'updateTime',
        },
        {
            label: '申请类型',
            selected: false,
            default: false,
            name: 'applyType',
            type: 'dict',
            dict: 'apply_type',
        },
    ],
}

export default fullEleInvoiceIsAbnormalConfig



// WEBPACK FOOTER //
// ./src/app/system/permission/registrationCodeManagement/fieldConfig.js